<template>
    <div class="content">
        <img src='https://preprod.api.defipix.fr/logos/logo_bg_white.png' alt="logo defipix" class="logoDP">        
        <div v-if="this.$route.query.reservation" class="btnBack" @click="closeTab()">
            <img src='https://preprod.api.defipix.fr/logos/retour_200.png' alt="logo defipix" class="imgBack">
            <p>Retourner a votre reservation</p>
        </div>
        <List :booths="booths" />
    </div>
</template>

<script>

import axios from 'axios';
import JQuery from 'jquery';
let $ = JQuery;
import List from '../components/Booths/List';

export default {    
    title: 'Défipix.fr | Nos bornes photos',
    data() {
        return {
            booths: [],
        }
    },
    mounted: function () {
        this.getBooths();
    },
    methods: {
        async getBooths() {
            try {
                const response = await axios.get('https://preprod.api.defipix.fr/booth');
                response.data.sort(function(a,b) {
                    return a.id - b.id;
                });
                this.booths = response.data;
            } catch (error) {
                console.error(error);
            }
        },
        closeTab() {
            window.close();
        }
    },
    components: {
        List
    }
}

</script>

<style scoped>
.content {
    padding-bottom: 2em;
    max-width: 82em;
    width: 90%;
    margin: auto;  
}

.logoDP {
    max-width: 15em;
    margin: auto;
    display: block;
}

.btnBack {
    z-index: 1;
    position: fixed;
    bottom: 3em;
    left: 3em;
    background-color: #25327B;
    color: #fff;
    padding: 1em;
    width: 12em;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #aaa;
}

.btnBack:hover {
    cursor: pointer;
}

.imgBack {
    display: block;
    margin: auto;
    width: 5em;
    margin-bottom: 1em;
}

@media only screen and (max-width: 765px) {

    .btnBack {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 15em;
        margin: auto;
        left: 0;
        right: 0;
    }

    .imgBack {
        width: 3em;
        margin: 0 1em 0 0;
    }

    .btnBack>p {
        margin: 0;
    }
}

</style>


// WEBPACK FOOTER //
// src/router/Booths.vue